module.exports = __webpack_public_path__ + "static/img/T_8PV5Kg.33762ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/T_8PV5Kg.jpg
// module id = jVbt
// module chunks = 7